import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import Container from './common/Container';
import Logo from './common/Logo';

export default function Header({ onMenuClick, isScrolledProp }) {
    const [isScrolledState, setIsScrolledState] = useState(false);
    const navigate = useNavigate();

    // Use prop if provided, otherwise local state
    const isScrolled = isScrolledProp !== undefined ? isScrolledProp : isScrolledState;

    // Scroll effect for header
    useEffect(() => {
        if (isScrolledProp !== undefined) return; // Skip window listener if controlled

        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolledState(true);
            } else {
                setIsScrolledState(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isScrolledProp]);

    return (
        <header
            className={`sticky top-0 left-0 w-full z-30 -mb-[78px] transition-all duration-500 ${isScrolled
                ? 'bg-white/90 backdrop-blur-md shadow-md py-3 text-primary'
                : 'bg-transparent backdrop-blur-sm md:backdrop-blur-none py-3 text-light'
                }`}
        >
            <Container className="flex justify-between items-center">
                {/* Logo */}
                <Link to="/" className="flex gap-2 items-center leading-none group relative z-50">
                    <motion.div
                        initial="rest"
                        whileHover="hover"
                        animate="rest"
                        className={`transition-all duration-300 ${isScrolled ? 'scale-90' : 'scale-100'}`}
                    >
                        <motion.div
                            variants={{
                                rest: { x: 0 },
                                hover: { x: 5 }
                            }}
                            transition={{ type: "spring", stiffness: 400, damping: 10 }}
                            className="flex gap-3 items-center border-l-2 border-secondary pl-3"
                        >

                            <Logo />
                            <div className='flex flex-col'>

                                <span className={`text-xl md:text-2xl font-serif font-bold tracking-[0.15em] ${isScrolled ? 'text-primary' : 'text-accent'}`}>VALLETTA</span>
                                <span className={`text-[10px] tracking-[0.3em] font-medium mt-0.5 ${isScrolled ? 'text-secondary' : 'text-light'}`}>GROUP</span>
                            </div>
                        </motion.div>
                    </motion.div>
                </Link>

                {/* Right Actions */}
                <div className="flex items-center gap-4 md:gap-8">
                    <button
                        onClick={() => {
                            navigate('/contact');
                        }}
                        className="hidden md:block bg-secondary hover:bg-accent text-surface px-6 py-2.5 text-xs font-bold uppercase tracking-widest transition-all duration-300 shadow-[0_0_15px_rgba(198,168,124,0.3)] hover:shadow-[0_0_20px_rgba(198,168,124,0.5)]"
                    >
                        Inquiry
                    </button>

                    {/* Menu Trigger - Using User's Preferred Style */}
                    <button
                        onClick={onMenuClick}
                        className="group flex flex-col items-end justify-center gap-1.5 p-2 text-primary hover:text-secondary transition-colors duration-300"
                    >
                        <span className="w-8 h-[2px] bg-secondary group-hover:w-10 transition-all duration-300"></span>
                        <span className="w-6 h-[2px] bg-primary group-hover:w-10 transition-all duration-300"></span>
                        <span className="w-4 h-[2px] bg-secondary group-hover:w-10 transition-all duration-300"></span>
                    </button>
                </div>
            </Container>
        </header>
    );
}
